module.exports = __webpack_public_path__ + "static/media/search--white.d65004a6.svg";